import React from "react";
import DynamicUniversityPage from "../../../custom-components/DynamicUniversityPage";
import { imiKolkataJson } from "./ImiKolkataJson";
import DynamicWhyChooseThisUniversitiesPage from "../../../custom-components/DynamicWhyChooseThisUniversityPage";
import UniversityKnowMore from "src/CountryPages/University/UniversityKnowMore";
import Location from "../../../custom-components/Location";
import DynamicUniversityDetails from "../../../custom-components/DynamicUniversityDetails";
import DynamicNationalitySelection from "../../../custom-components/DynamicNationalitySelection";

const ImiKolkata = () => {
  const { heading, backgroundImage, content } = imiKolkataJson.BannerData;

  return (
    <>
      <DynamicUniversityPage
        heading={heading}
        backgroundImage={backgroundImage}
        content={content}
      />
      <DynamicUniversityDetails data={imiKolkataJson.universityDetails} />
      <DynamicWhyChooseThisUniversitiesPage
        rankingsData={imiKolkataJson?.WhyChooseThisUniversityPage}
      />
       <DynamicNationalitySelection data={imiKolkataJson} />
      <Location
        header={imiKolkataJson?.Location.header}
        image={imiKolkataJson?.Location.image}
        content={imiKolkataJson?.Location?.content || "No content available"}
      />
      <UniversityKnowMore data={imiKolkataJson?.KnowMore} />
    </>
  );
};

export default ImiKolkata;
